import * as React from "react";

import './CardButton.pcss';

interface Props {
  buttonAction:()=>void;
  buttonLabel?:string;
  hideLabel?:boolean;
  hideArrow?:boolean;
  variant?:'standard'|'outlined';
  ariaButtonLabel?:string;
}

export function CardButton(props:Props) {
  let buttonProps = {
    onClick:props.buttonAction
  }
  return (
    <div className={`${'outlined'===props.variant?'outlined-card-button':'cardButton'}`}>
      <button
        aria-label={props.ariaButtonLabel?props.ariaButtonLabel:props.buttonLabel}
        tabIndex={0}
        className={`${props.variant?props.variant:''}`} {...buttonProps}>{!props.hideLabel&&<span className={"lab"}>{props.buttonLabel}</span>}{!props.hideArrow && <span aria-hidden={true} className={`material-symbols-outlined${props.hideLabel?' arrow-only':''}`}>arrow_forward_ios</span>}</button></div>
  )
}
